export default __webpack_public_path__ + "static/media/insta.87eee118.svg";